// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"nO-z","carouselContainer":"oO-z"};